@let showError = inputFormControl().invalid && isSubmitted();
<div class="d-flex flex-column gap-1">
  <label class="form-input-label" [for]="inputId">{{ label() }}</label>
  <lib-typeahead-input
    #typeaheadInputComponent
    [initialSelectedName]="filteredInitialSelectedName()"
    [loading]="loadingResults()"
    [results]="resultStrings()"
    [formControl]="textInputFormControl"
    [error]="showError"
    [controlId]="inputId"
    [placeholder]="placeholder()"
    (valueChange)="valueChange($event)"
    (resultIndexSelected)="resultIndexSelected($event)">
  </lib-typeahead-input>
  @if (hintText()) {
    <div class="form-input-hint-label" [class.disabled]="inputFormControl().disabled">
      {{ hintText() }}
    </div>
  }
  @if (showError) {
    <lib-form-error [errors]="inputFormControl().errors"></lib-form-error>
  }
</div>
